// extracted by mini-css-extract-plugin
export default {"content":"DeleteStep_content__o0ybn"};